export default __webpack_public_path__ + "static/media/fileBundle.8fd7b30d.svg";